import { Button } from 'components/buttons';
import plus from 'assets/icons/commons/roundPlus.svg';

interface IAddNewDeliveryProps {
    toOpenDeliveryFormModal: () => void;
    toCloseModalMenu: () => void;
}

function AddNewDeliveryBtn({
        toOpenDeliveryFormModal,
        toCloseModalMenu
    }: IAddNewDeliveryProps) {

    function clickHandler() {
        toOpenDeliveryFormModal();
        toCloseModalMenu();
    }

    return (
        <Button
            clickHandler={clickHandler}
            appearance="primary"
            customClassName="button-add"
        >
            <div className="flex justify-around w-[150px] items-center">
                <img src={plus} className="w-4 h-4" />
                <div>Добавить поставку</div>
            </div>
        </Button>
    );
}

export default AddNewDeliveryBtn;
